module.exports = __webpack_public_path__ + "img/logo.7a4749d7.png";